"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Health+Status
 */
var React = require("react");
var classNames = require("classnames");
var Aria_1 = require("../../resources/Aria");
var status_1 = require("./status");
/**
 * OUI health badge component.
 *
 * @oui-component HealthBadge
 */
var HealthBadge = function (_a) {
    var statusType = _a.statusType, displayValue = _a.displayValue, testId = _a.testId, _b = _a.isFilled, isFilled = _b === void 0 ? true : _b, children = _a.children, rest = __rest(_a, ["statusType", "displayValue", "testId", "isFilled", "children"]);
    // Because the text and badge colors don't match(some times) we need to map them.
    var colors = status_1.getStyles(statusType);
    var hgds = true;
    var wrapperClassNames = classNames("oui-display-inline-block", hgds && "oui-health-badge__container", !hgds && colors.text);
    var badgeClassNames = classNames("oui-label", "oui-center-status", "oui-padding-small", colors.badge, {
        "oui-label-empty": !isFilled,
        "oui-padding-remove-vertical": !hgds,
        "oui-margin-right": hgds,
        "oui-margin-small-right": !hgds
    });
    return (React.createElement("span", __assign({ className: wrapperClassNames, role: Aria_1.Roles.Status, "data-test-id": testId }, rest),
        React.createElement("span", { className: badgeClassNames }, displayValue),
        children));
};
/**
 * A health badge component.
 */
exports.default = HealthBadge;
//# sourceMappingURL=HealthBadge.js.map